exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loadingContainer___1WaHu {\n  width: 100%;\n}\n.container___3XVjB {\n  display: flex;\n  flex-direction: column;\n}\n@media (max-width: 991px) {\n  .container___3XVjB {\n    width: 444px;\n    flex: 0 0 50%;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .container___3XVjB {\n    width: 562px;\n  }\n}\n@media (min-width: 1200px) {\n  .container___3XVjB {\n    width: 640px;\n  }\n}\n.marginBottom___2UI4l {\n  margin-bottom: 12px;\n}\n.title___160Jk {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 24px;\n  font-weight: 500;\n  margin: 0 0 20px 0;\n}\n.subTitle___96hzC {\n  font-family: 'proxima-nova', 'Helvetica', Arial, sans-serif;\n  font-size: 20px;\n  font-weight: 500;\n  margin: 40px 0 12px 0;\n}\n", ""]);

// exports
exports.locals = {
	"loadingContainer": "loadingContainer___1WaHu",
	"container": "container___3XVjB",
	"marginBottom": "marginBottom___2UI4l",
	"title": "title___160Jk",
	"subTitle": "subTitle___96hzC"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/VirtualEvents/ZoomCreate/zoomCreate.module.less
// module id = 2352
// module chunks = 51